import React from 'react';
import PropTypes from 'prop-types';

// "Meds to Pack Separately" — the free-text note a pharmacist writes on an order
// (userOrders.additionalDetails.extraItems, set from the Add Extra Items modal on the order
// edit page).
//
// Shown at the point of PACKING, which is where it is actionable: inside the Create Delivery
// modal, and behind a row action on the Delivery Queue. Until now it was only visible on the
// logistics Orders tab — a screen the person physically packing the box has no reason to be
// looking at.
//
// Deliberately loud (amber, warning icon, not collapsed): the whole reason the field exists
// is that these items must NOT go in the pouches — cold-chain, controlled, fragile. A quiet
// grey line is the wrong weight for "do not pack this normally".
//
// Renders nothing at all when there is no note, so callers can mount it unconditionally.
function ExtraItemsNotice({ extraItems, className = '' }) {
    const text = typeof extraItems === 'string' ? extraItems.trim() : '';
    if (!text) return null;

    return (
        <div className={`flex gap-2 rounded-lg border border-amber-300 bg-amber-50 p-3 ${className}`}>
            <span className="text-amber-600 text-[1.3rem] leading-none" aria-hidden="true">⚠</span>
            <div className="flex flex-col gap-1">
                <span className="text-[1.1rem] font-semibold text-amber-800">
                    Pack these separately
                </span>
                {/* whitespace-pre-wrap: pharmacists enter multi-line lists, and collapsing
                    them into one paragraph loses the per-item structure. */}
                <span className="text-[1.1rem] text-amber-900 whitespace-pre-wrap">{text}</span>
            </div>
        </div>
    );
}

ExtraItemsNotice.propTypes = {
    extraItems: PropTypes.string,
    className: PropTypes.string,
};

export default ExtraItemsNotice;
